// Generated by Melange

import * as Buhta_commonapis__Buhta_common_v1_grid from "../../commonapis/gen/buhta_common_v1_grid.js";
import * as Buhta_kassaapis__Buhta_kassa_v1alpha1_journal_log from "./buhta_kassa_v1alpha1_journal_log.js";
import * as Caml_module from "melange.js/caml_module.js";
import * as Curry from "melange.js/curry.js";
import * as Ocaml_protoc_plugin from "../../../vendored/ocaml_protoc_plugin/ocaml_protoc_plugin.js";
import * as Ocaml_protoc_plugin__Deserialize from "../../../vendored/ocaml_protoc_plugin/deserialize.js";
import * as Ocaml_protoc_plugin__Deserialize_json from "../../../vendored/ocaml_protoc_plugin/deserialize_json.js";
import * as Ocaml_protoc_plugin__Merge from "../../../vendored/ocaml_protoc_plugin/merge.js";
import * as Ocaml_protoc_plugin__Result from "../../../vendored/ocaml_protoc_plugin/result.js";
import * as Ocaml_protoc_plugin__Serialize from "../../../vendored/ocaml_protoc_plugin/serialize.js";
import * as Ocaml_protoc_plugin__Serialize_json from "../../../vendored/ocaml_protoc_plugin/serialize_json.js";
import * as Ocaml_protoc_plugin__Spec from "../../../vendored/ocaml_protoc_plugin/spec.js";
import * as Ocaml_protoc_plugin__Writer from "../../../vendored/ocaml_protoc_plugin/writer.js";

const Imported$pmodules = {};

const ListJournalLogsRequest = Caml_module.init_mod([
      "proto/kassaapis/gen/buhta_kassa_v1alpha1_journal_log_service.ml",
      299,
      12
    ], {
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    });

const ListJournalLogsResponse = Caml_module.init_mod([
      "proto/kassaapis/gen/buhta_kassa_v1alpha1_journal_log_service.ml",
      362,
      12
    ], {
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    });

function name(param) {
  return ".buhta.kassa.v1alpha1.ListJournalLogsRequest";
}

function make(kkm_idOpt, grid, param) {
  const kkm_id = kkm_idOpt !== undefined ? kkm_idOpt : 0;
  return {
          kkm_id: kkm_id,
          grid: grid
        };
}

const merge_kkm_id = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
          [
            1,
            "kkm_id",
            "kkmId"
          ],
          Ocaml_protoc_plugin__Spec.int32_int,
          0
        ]));

const $$let = Buhta_commonapis__Buhta_common_v1_grid.Buhta.Common.V1.GridRequest;

const merge_grid = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic_opt([
          [
            2,
            "grid",
            "grid"
          ],
          Ocaml_protoc_plugin__Spec.message({
                name: $$let.name,
                make: $$let.make,
                from_proto: $$let.from_proto,
                from_proto_exn: $$let.from_proto_exn,
                to_proto: $$let.to_proto,
                to_proto$p: $$let.to_proto$p,
                merge: $$let.merge,
                to_json: $$let.to_json,
                from_json_exn: $$let.from_json_exn,
                from_json: $$let.from_json
              })
        ]));

function merge(t1, t2) {
  return {
          kkm_id: Curry._2(merge_kkm_id, t1.kkm_id, t2.kkm_id),
          grid: Curry._2(merge_grid, t1.grid, t2.grid)
        };
}

function spec(param) {
  const $$let = Buhta_commonapis__Buhta_common_v1_grid.Buhta.Common.V1.GridRequest;
  return Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
                  [
                    1,
                    "kkm_id",
                    "kkmId"
                  ],
                  Ocaml_protoc_plugin__Spec.int32_int,
                  0
                ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic_opt([
                      [
                        2,
                        "grid",
                        "grid"
                      ],
                      Ocaml_protoc_plugin__Spec.message({
                            name: $$let.name,
                            make: $$let.make,
                            from_proto: $$let.from_proto,
                            from_proto_exn: $$let.from_proto_exn,
                            to_proto: $$let.to_proto,
                            to_proto$p: $$let.to_proto$p,
                            merge: $$let.merge,
                            to_json: $$let.to_json,
                            from_json_exn: $$let.from_json_exn,
                            from_json: $$let.from_json
                          })
                    ]), Ocaml_protoc_plugin__Spec.nil));
}

const serialize = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Serialize.serialize(spec(undefined));
    });

function to_proto$p(writer, param) {
  Curry._3(serialize, writer, param.kkm_id, param.grid);
}

function to_proto(t) {
  const writer = Ocaml_protoc_plugin__Writer.init(undefined, undefined, undefined);
  to_proto$p(writer, t);
  return writer;
}

function constructor(kkm_id, grid) {
  return {
          kkm_id: kkm_id,
          grid: grid
        };
}

const from_proto_exn = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize.deserialize(spec(undefined), constructor);
    });

function from_proto(writer) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_proto_exn, writer);
            });
}

function to_json(options) {
  const serialize = Ocaml_protoc_plugin__Serialize_json.serialize(".buhta.kassa.v1alpha1.ListJournalLogsRequest", spec(undefined))(options);
  return function (param) {
    return Curry._2(serialize, param.kkm_id, param.grid);
  };
}

function constructor$1(kkm_id, grid) {
  return {
          kkm_id: kkm_id,
          grid: grid
        };
}

const from_json_exn = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize_json.deserialize(".buhta.kassa.v1alpha1.ListJournalLogsRequest", spec(undefined), constructor$1);
    });

function from_json(json) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_json_exn, json);
            });
}

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    }, ListJournalLogsRequest, {
      make: make,
      to_proto: to_proto,
      from_proto: from_proto,
      to_json: to_json,
      from_json: from_json,
      name: name,
      merge: merge,
      to_proto$p: to_proto$p,
      from_proto_exn: from_proto_exn,
      from_json_exn: from_json_exn
    });

function name$1(param) {
  return ".buhta.kassa.v1alpha1.ListJournalLogsResponse";
}

function make$1(journal_logsOpt, param) {
  const journal_logs = journal_logsOpt !== undefined ? journal_logsOpt : /* [] */0;
  return {
          journal_logs: journal_logs
        };
}

const $$let$1 = Buhta_kassaapis__Buhta_kassa_v1alpha1_journal_log.Buhta.Kassa.V1alpha1.JournalLog;

const merge_journal_logs = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.repeated([
          [
            1,
            "journal_logs",
            "journalLogs"
          ],
          Ocaml_protoc_plugin__Spec.message({
                name: $$let$1.name,
                make: $$let$1.make,
                from_proto: $$let$1.from_proto,
                from_proto_exn: $$let$1.from_proto_exn,
                to_proto: $$let$1.to_proto,
                to_proto$p: $$let$1.to_proto$p,
                merge: $$let$1.merge,
                to_json: $$let$1.to_json,
                from_json_exn: $$let$1.from_json_exn,
                from_json: $$let$1.from_json
              }),
          Ocaml_protoc_plugin__Spec.not_packed
        ]));

function merge$1(t1, t2) {
  return {
          journal_logs: Curry._2(merge_journal_logs, t1.journal_logs, t2.journal_logs)
        };
}

function spec$1(param) {
  const $$let = Buhta_kassaapis__Buhta_kassa_v1alpha1_journal_log.Buhta.Kassa.V1alpha1.JournalLog;
  return Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.repeated([
                  [
                    1,
                    "journal_logs",
                    "journalLogs"
                  ],
                  Ocaml_protoc_plugin__Spec.message({
                        name: $$let.name,
                        make: $$let.make,
                        from_proto: $$let.from_proto,
                        from_proto_exn: $$let.from_proto_exn,
                        to_proto: $$let.to_proto,
                        to_proto$p: $$let.to_proto$p,
                        merge: $$let.merge,
                        to_json: $$let.to_json,
                        from_json_exn: $$let.from_json_exn,
                        from_json: $$let.from_json
                      }),
                  Ocaml_protoc_plugin__Spec.not_packed
                ]), Ocaml_protoc_plugin__Spec.nil);
}

const serialize$1 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Serialize.serialize(spec$1(undefined));
    });

function to_proto$p$1(writer, param) {
  Curry._2(serialize$1, writer, param.journal_logs);
}

function to_proto$1(t) {
  const writer = Ocaml_protoc_plugin__Writer.init(undefined, undefined, undefined);
  to_proto$p$1(writer, t);
  return writer;
}

function constructor$2(journal_logs) {
  return {
          journal_logs: journal_logs
        };
}

const from_proto_exn$1 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize.deserialize(spec$1(undefined), constructor$2);
    });

function from_proto$1(writer) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_proto_exn$1, writer);
            });
}

function to_json$1(options) {
  const serialize = Ocaml_protoc_plugin__Serialize_json.serialize(".buhta.kassa.v1alpha1.ListJournalLogsResponse", spec$1(undefined))(options);
  return function (param) {
    return Curry._1(serialize, param.journal_logs);
  };
}

function constructor$3(journal_logs) {
  return {
          journal_logs: journal_logs
        };
}

const from_json_exn$1 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize_json.deserialize(".buhta.kassa.v1alpha1.ListJournalLogsResponse", spec$1(undefined), constructor$3);
    });

function from_json$1(json) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_json_exn$1, json);
            });
}

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    }, ListJournalLogsResponse, {
      make: make$1,
      to_proto: to_proto$1,
      from_proto: from_proto$1,
      to_json: to_json$1,
      from_json: from_json$1,
      name: name$1,
      merge: merge$1,
      to_proto$p: to_proto$p$1,
      from_proto_exn: from_proto_exn$1,
      from_json_exn: from_json_exn$1
    });

const listJournalLogs_0 = {
  name: ListJournalLogsRequest.name,
  make: ListJournalLogsRequest.make,
  from_proto: ListJournalLogsRequest.from_proto,
  from_proto_exn: ListJournalLogsRequest.from_proto_exn,
  to_proto: ListJournalLogsRequest.to_proto,
  to_proto$p: ListJournalLogsRequest.to_proto$p,
  merge: ListJournalLogsRequest.merge,
  to_json: ListJournalLogsRequest.to_json,
  from_json_exn: ListJournalLogsRequest.from_json_exn,
  from_json: ListJournalLogsRequest.from_json
};

const listJournalLogs_1 = {
  name: ListJournalLogsResponse.name,
  make: ListJournalLogsResponse.make,
  from_proto: ListJournalLogsResponse.from_proto,
  from_proto_exn: ListJournalLogsResponse.from_proto_exn,
  to_proto: ListJournalLogsResponse.to_proto,
  to_proto$p: ListJournalLogsResponse.to_proto$p,
  merge: ListJournalLogsResponse.merge,
  to_json: ListJournalLogsResponse.to_json,
  from_json_exn: ListJournalLogsResponse.from_json_exn,
  from_json: ListJournalLogsResponse.from_json
};

const listJournalLogs = [
  listJournalLogs_0,
  listJournalLogs_1
];

const V1alpha1_JournalLogService = {
  ListJournalLogs: {
    name: "/buhta.kassa.v1alpha1.JournalLogService/ListJournalLogs",
    package_name: "buhta.kassa.v1alpha1",
    service_name: "JournalLogService",
    method_name: "ListJournalLogs",
    $$Request: {
      name: ListJournalLogsRequest.name,
      make: ListJournalLogsRequest.make,
      from_proto: ListJournalLogsRequest.from_proto,
      from_proto_exn: ListJournalLogsRequest.from_proto_exn,
      to_proto: ListJournalLogsRequest.to_proto,
      to_proto$p: ListJournalLogsRequest.to_proto$p,
      merge: ListJournalLogsRequest.merge,
      to_json: ListJournalLogsRequest.to_json,
      from_json_exn: ListJournalLogsRequest.from_json_exn,
      from_json: ListJournalLogsRequest.from_json
    },
    $$Response: {
      name: ListJournalLogsResponse.name,
      make: ListJournalLogsResponse.make,
      from_proto: ListJournalLogsResponse.from_proto,
      from_proto_exn: ListJournalLogsResponse.from_proto_exn,
      to_proto: ListJournalLogsResponse.to_proto,
      to_proto$p: ListJournalLogsResponse.to_proto$p,
      merge: ListJournalLogsResponse.merge,
      to_json: ListJournalLogsResponse.to_json,
      from_json_exn: ListJournalLogsResponse.from_json_exn,
      from_json: ListJournalLogsResponse.from_json
    }
  },
  listJournalLogs: listJournalLogs
};

const V1alpha1 = {
  ListJournalLogsRequest: ListJournalLogsRequest,
  ListJournalLogsResponse: ListJournalLogsResponse,
  JournalLogService: V1alpha1_JournalLogService
};

const Kassa = {
  V1alpha1: V1alpha1
};

const Buhta = {
  Kassa: Kassa
};

export {
  Imported$pmodules ,
  Buhta ,
}
/* ListJournalLogsRequest Not a pure module */
